module.exports = __webpack_public_path__ + "img/25.a3135eb3.jpg";